import React, { useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import classNames from 'classnames'
import BistroMenu from './BistroMenu'
import bistroStyles from './bistro.module.sass'
import useScrollToSection from '../hooks/useScrollToSection'

export default props => {
  const { acf } = props
  const [scrollTo] = useScrollToSection()
  const sectionsRef = useRef([])
  const { menus } = acf.bistromenus
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  const handleSelect = event => {
    const targetKey = event.target.value
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]/g, '')
    scrollTo(sectionsRef.current[targetKey])
  }

  const MenuType = ({ menu }) => (
    <option id={menu.type} value={menu.type}>
      {menu.type}
    </option>
  )

  // const text = 'Order Online'
  // const url =
  //   'https://secure.ordyx.com/olo/v2/Home.jsp?store_id=693&token=2844113296000'

  const Menus = () => (
    <div className={bistroStyles.menus} ref={ref}>
      {menus &&
        menus.map(
          menu =>
            menu.items && (
              <BistroMenu
                menu={menu}
                key={menu.type}
                sectionsRef={sectionsRef}
              />
            )
        )}
    </div>
  )

  return (
    <div className={bistroStyles.bistromenus}>
      <div className={bistroStyles.content}>
        <h2 className={bistroStyles.sectiontitle}>
          {acf.bistromenus.menu_section_title}
        </h2>
        <p className={bistroStyles.intro}>{acf.bistromenus.menu_intro}</p>
        <select
          onChange={handleSelect}
          className={classNames(
            bistroStyles.jump,
            `${inView ? bistroStyles.visible : ''}` //we could reverse the animation with some clever class manipulation here
          )}
        >
          <option>Jump to:</option>
          {menus &&
            menus.map((menu, index) => (
              <MenuType menu={menu} key={menu.type} index={index} />
            ))}
        </select>
        <Menus />
      </div>
    </div>
  )
}
